<template>
    <AdminPanelYoutvShoppingPacket />
   </template>
   
   <script>
   import AdminPanelYoutvShoppingPacket  from '../components/AdminPanelYoutvShoppingPacket.vue'
   export default {
       data: () => ({}),
       components: {
           AdminPanelYoutvShoppingPacket
       },
       methods: {},
       mounted() {}
   }
   </script>
   